<template>
  <div v-if="show" class="modal-overlay" @click.self="close">
    <div class="modal-container">
      <div class="modal-header">
        <h2 class="modal-title">Athlete Profile</h2>
        <button class="close-button" @click="close">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="modal-content">
        <!-- <div class="feature-image">
          <img
            src="/DashLogo.png"
            alt="Athlete Profile Dashboard"
            class="rounded-lg shadow-md"
          />
        </div> -->

        <h3 class="section-title">Elevate Your Athletic Journey</h3>
        <p class="description">
          The Athlete Profile account gives you powerful tools to connect with
          your coaches, stay up to date on events, and showcase your talents.
        </p>

        <div class="features">
          <div class="feature-item">
            <i class="fas fa-chart-line feature-icon"></i>
            <div class="feature-text">
              <h4>Activity Tracking</h4>
              <p>
                View all your activities, their updates, and their information
                in one centralized hub.
              </p>
            </div>
          </div>

          <div class="feature-item">
            <i class="fas fa-comments feature-icon"></i>
            <div class="feature-text">
              <h4>Coach Communication</h4>
              <p>
                Communicate directly with your coaches to see event updates,
                group messages, and reach out with your questions.
              </p>
            </div>
          </div>

          <div class="feature-item">
            <i class="fas fa-globe feature-icon"></i>
            <div class="feature-text">
              <h4>Profile Website</h4>
              <p>
                Create an online athlete profile to showcase your highlights,
                achievements, and stats.
              </p>
            </div>
          </div>

          <div class="feature-item">
            <i class="fas fa-user-graduate feature-icon"></i>
            <div class="feature-text">
              <h4>Recruiter Visibility</h4>
              <p>
                Showcase your highlights to coaches and recruiters looking for
                talented athletes.
              </p>
            </div>
          </div>
        </div>

        <!-- <div class="pricing-section">
          <div class="price-tag">
            <span class="price">$15</span>
            <span class="period">/month</span>
          </div>
          <p class="value-proposition">
            Invest in your athletic future with tools used by elite athletes.
          </p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AthleteProfileModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background-color: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(3, 0, 33, 0.25); /* Using #030021 with opacity */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #363166; /* Your dark blue/purple brand color */
}

.modal-title {
  color: white;
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.close-button {
  background: transparent;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
}

.modal-content {
  padding: 20px;
  color: #030021; /* Your very dark brand color for text */
}

.feature-image {
  margin-bottom: 20px;
  text-align: center;
}

.feature-image img {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border: 2px solid #363166; /* Your dark blue/purple brand color */
}

.section-title {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  color: #363166; /* Your dark blue/purple brand color */
}

.description {
  text-align: center;
  margin-bottom: 25px;
  color: #030021; /* Your very dark brand color */
  font-size: 1rem;
}

.features {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 25px;
}

@media (min-width: 640px) {
  .features {
    grid-template-columns: 1fr 1fr;
  }
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.feature-icon {
  font-size: 1.5rem;
  color: #19d412; /* Your bright green brand color */
  margin-top: 3px;
}

.feature-text h4 {
  margin: 0 0 5px 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #363166; /* Your dark blue/purple brand color */
}

.feature-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #030021; /* Your very dark brand color */
}

.pricing-section {
  text-align: center;
  margin-top: 20px;
  padding: 15px;
  background-color: rgba(
    54,
    49,
    102,
    0.1
  ); /* Your dark blue/purple brand color with opacity */
  border-radius: 8px;
  border-left: 4px solid #19d412; /* Your bright green brand color */
}

.price-tag {
  font-weight: 700;
  margin-bottom: 10px;
  color: #363166; /* Your dark blue/purple brand color */
}

.price {
  font-size: 2rem;
}

.period {
  font-size: 1rem;
  opacity: 0.8;
}

.value-proposition {
  margin: 0;
  font-size: 0.95rem;
  color: #030021; /* Your very dark brand color */
}

.modal-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid rgba(3, 0, 33, 0.1); /* Using #030021 with opacity */
}

.close-btn {
  padding: 8px 20px;
  background-color: #363166; /* Your dark blue/purple brand color */
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background-color 0.2s,
    transform 0.1s;
}

.close-btn:hover {
  background-color: #19d412; /* Your bright green brand color */
  transform: translateY(-1px);
}
</style>
